import React from "react";
import {Tag} from "antd";
import cn from "classnames";
import {IconCloseRound} from "components/icons";

// color: "blue" | "red" | "green" | "purple" | "orange" | "link"
export const ClosableTags = ({
  tags = [],
  suffixData,
  addClass,
  tagClass,
  close,
  field,
  index,
  small,
  color,
  hoverable,
  onClick,
  dontRemove = [],
  isRelativeCustomContent,
  customContent,
}) => {
  const handleClose = (tag) => {
    if (!close) return;

    const filteredTags = field
      ? tags.filter((item) => item[index] !== tag[index])
      : tags.filter((item) => item !== tag);

    close(filteredTags);
  };

  const isRemovable = (tag) => {
    if (!dontRemove.length) return true;

    return tag instanceof Object
      ? !dontRemove.some((item) => item.id === tag.id)
      : !dontRemove.includes(tag);
  };

  if (!tags.length) return null;

  return (
    <div className={cn("closable-tags_wrapper", addClass, {__small: small})}>
      {tags.map((tag, i) => {
        const key = tag?.id || i;
        const removable = isRemovable(tag);

        return (
          <React.Fragment key={key}>
            <Tag
              className={cn("closable-tags_tag", {
                "pr-3": !close || !removable,
                "mr-2": field !== "email",
                __strikethrough: field === "email" && !!tag.isBounced,
                [tagClass]: !!tagClass,
                [color]: !!color,
                __small: small,
                __hoverable: hoverable,
                __clickable: !!onClick,
              })}
              closable={close ? removable : false}
              onClose={() => handleClose(tag)}
              onClick={() => onClick && onClick(tag)}
            >
              {field ? tag[field] : tag}
              {suffixData}
              {close && removable && <IconCloseRound />}
            </Tag>
            {isRelativeCustomContent && (
              <div style={{position: "relative"}}>{customContent}</div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
